module.exports = "<svg id=\"ff4a8249-59a5-4e5d-8678-523e1381bfb9\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>wsua-2</title><path d=\"M25,.42A16.46,16.46,0,0,0,8.17,17.14a19.58,19.58,0,0,0,1.38,6.26c4.69,10.19,8.37,16,15.45,26.19C32.18,38.9,36.16,33.49,40.84,23.39a19.21,19.21,0,0,0,1-6.26A16.52,16.52,0,0,0,25,.42ZM24.85,27.5A10.22,10.22,0,1,1,35,17.28,10.17,10.17,0,0,1,24.85,27.5Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/wsua-7.svg
// module id = 8NLN
// module chunks = 2